'use client';

import TextSplitter from '~/components/molecules/TextSplitter';
import { stripHtml } from '~/lib/utils/string';

interface Props {
  textContent: string;
  isParentIntersecting: boolean;
}

const LargeTextSplitter: React.FC<Props> = ({
  textContent,
  isParentIntersecting,
}) => {
  return (
    <TextSplitter
      text={stripHtml(textContent)}
      wordWrapperClassName="relative inline-block overflow-clip"
      generateWordProps={({ index }) => ({
        variants: {
          hidden: {
            opacity: 0,
            y: 0,
            transition: {
              delay: index * 0.02,
            },
          },
          visible: {
            opacity: 1,
            y: ['-120%', 0],
          },
        },

        animate: isParentIntersecting ? 'visible' : 'hidden',

        transition: {
          type: 'spring',
          bounce: 0,
          visualDuration: 0.3,
          delay: 0.25 + index * 0.025,
        },
      })}
      useMotion
    />
  );
};

export default LargeTextSplitter;
